import React, { FunctionComponent, memo } from 'react';

// Utils
import Anchor from '@Components/Utils/Anchor';

// components
import Image from '@Components/Utils/Image';

// NPM
import classnames from 'classnames';

// styles
import styles from './DoctorQuestion.module.scss';

// Icons
import { faStar } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export interface DoctorQuestionProps {
    id?: string;
    avatar?: string;
    average?: number;
    className?: string;
    experience?: number;
    doctorName?: string;
    isViewInfoDoctor?: boolean;
}

const DoctorQuestion: FunctionComponent<DoctorQuestionProps> = memo(
    ({ avatar, average, className, doctorName, experience, id, isViewInfoDoctor }) => {
        const wrapperClassName = classnames([styles.wrapper, className]);

        const renderLink = (children) => {
            return isViewInfoDoctor ? (
                <Anchor href={`/bac-si/${id}`} className={styles.anchor} key={1}>
                    {children}
                </Anchor>
            ) : (
                children
            );
        };
        return (
            <div className={wrapperClassName}>
                {renderLink(
                    <>
                        <Image className={styles.doctor_avatar} src={avatar} width={32} height={32} />
                        <div className={styles.hint}>Được trả lời bởi</div>
                        <div className={styles.name}>{doctorName}</div>
                        <div className={styles.experience}>
                            {`${experience > 0 ? experience : 'Chưa rõ'} năm kinh nghiệm`}
                            <FontAwesomeIcon className={styles.star} icon={faStar} width={12} height={12} />
                            <span>{Number(average).toFixed(1)}</span>
                        </div>
                    </>,
                )}
            </div>
        );
    },
);

DoctorQuestion.defaultProps = {
    average: 5,
    className: '',
    experience: 0,
    doctorName: 'BS. Chưa rõ',
};

export default DoctorQuestion;
